import React from "react";

export default function MSAccess_StrReverse() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MSAccess_StrReverse</h1>
      <p>This is the MSAccess_StrReverse component generated from the SQL JSON.</p>
    </div>
  );
}
